import { NgModule } from '@angular/core';
import { ListCenterDepartmentComponent } from './list-center-department/list-center-department.component';
import { CenterDepartmentAjoutFormModalComponent } from './center-department-ajout-form-modal/center-department-ajout-form-modal.component';
import { DetailCenterDepartmentComponent } from './detail-center-department/detail-center-department.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { GestionDonneesModule } from '../gestion-donnees/gestion-donnees.module';
import { CenterDepartmentFormComponent } from './center-department-form/center-department-form.component';

@NgModule({
	declarations: [
		ListCenterDepartmentComponent,
		CenterDepartmentAjoutFormModalComponent,
		CenterDepartmentFormComponent,
		DetailCenterDepartmentComponent
	],
	imports: [SharedModule, GestionDonneesModule],
	providers: []
})
export class CenterDepartmentsModule {}
